@if (authService.isTruckDriver) {
    <app-driver-dash></app-driver-dash>
}
@else if (authService.isBreakdownTechnician) {
    <app-bdtech-dash></app-bdtech-dash>
}
@else {
    <app-callcentre-dash></app-callcentre-dash>
}

